import { API_URLS, NOTIFICATIONS_BOT_URLS } from 'constants/api';
import { COINDISCO_WIDGET_URL } from 'constants/urls';

import { getEnv } from './env';

export const getHorizonUrl = () => API_URLS[getEnv()].horizon;
export const getSorobanUrl = () => API_URLS[getEnv()].soroban;
export const getAmmAquaUrl = () => API_URLS[getEnv()].ammAqua;
export const getGovernanceUrl = () => API_URLS[getEnv()].governance;
export const getRewardsApiUrl = () => API_URLS[getEnv()].rewards;
export const getBribesApiUrl = () => API_URLS[getEnv()].bribes;
export const getMarketKeysApiUrl = () => API_URLS[getEnv()].marketKeys;
export const getVotingTrackerApiUrl = () => API_URLS[getEnv()].votingTracker;
export const getDelegationApiUrl = () => API_URLS[getEnv()].delegation;
export const getIceApprovalApiUrl = () => API_URLS[getEnv()].iceApproval;
export const getIceLockerApiUrl = () => API_URLS[getEnv()].iceLocker;
export const getNotificationsApiUrl = () => API_URLS[getEnv()].notifications;
export const getNotificationsBotUrls = () => NOTIFICATIONS_BOT_URLS[getEnv()];

export const getOnRampWidgetUrl = (params): string => {
    const urlParams = new URLSearchParams(params).toString();
    return `${COINDISCO_WIDGET_URL}?${urlParams}`;
};

export const normalizePath = (path: string) => (path !== '/' ? path.replace(/\/+$/, '') : path);
